import type { RouteObject } from "react-router-dom";
import { AddMemberPage } from "./AddMemberPage";
import { MembersPage } from "./MembersPage";
import { ProfilePage } from "./ProfilePage";

/** Static `/members/new` is registered before `/members/:id` (the router ranks it first either way). */
export const routes: RouteObject[] = [
  { path: "members", element: <MembersPage /> },
  { path: "members/new", element: <AddMemberPage /> },
  { path: "members/:id", element: <ProfilePage /> },
];
